<script setup lang="ts">
const isRender = ref(process.env.NODE_ENV !== 'development')
</script>

<template>
  <slot v-if="isRender" />
</template>
